<script>
  import NavBar from "./NavBar.svelte";
  import Footer from "./Footer.svelte";
  import SideBar from "./SideBar.svelte";
  import axios from "axios";
  import config from "../stores/config";
  import { onMount } from "svelte";
  import { Pulse } from "svelte-loading-spinners";
  import * as ls from "local-storage";

  let loading = true;

  onMount(async () => {
    // If the current user is not in store, add him
    if (!$config.currentUser) {
      try {
        let authData = {
          headers: {
            authorization: ls.get("jwt"),
          },
        };

        const response = await Promise.all([
          axios.get(`${$config.backendURL}/me`, authData),
          axios.get(`${$config.backendURL}/suppliers/names`),
          axios.get(`${$config.backendURL}/customers/names`),
          axios.get(`${$config.backendURL}/items/names`),
          axios.get(`${$config.backendURL}/fstyles/names`),
          axios.get(`${$config.backendURL}/cmts/names`),
        ]);

        // If he was not found in the session, login first
        if (response[0].data.error) window.location = "/#/login";

        config.update((prev) => ({
          ...prev,
          currentUser: response[0].data,
          suppliers: response[1].data,
          customers: response[2].data,
          items: response[3].data,
          fstyles: response[4].data,
          cmts: [
            { value: "fabi", label: "Fabi - No CMT" },
            ...response[5].data,
          ],
        }));

        loading = false;
      } catch (err) {
        console.log(err);
        window.location = "/#/login";
        window.location.reload();
      }
    } else {
      loading = false;
      // If he was not found in the session, login first
      if (!$config.currentUser.username) {
        window.location = "/#/login";
        window.location.reload();
      }
    }
  });
</script>

<div
  class={`tracking-wide font-normal min-h-screen flex`}
  style="background-color: #FAFAFA;"
  id="home"
>
  <div style="background-image: url(./images/pattern.svg)">
    <SideBar />

    {#if loading}
      <div
        class="loading-screen h-screen flex items-center justify-center"
        style="background: #FAFAFA"
      >
        <Pulse size="100" color="rgb(16, 185, 129)" unit="px" />
      </div>
    {:else}
      <div class="content">
        <NavBar />
        <div class="w-full pl-4 pr-6">
          <slot />

          <!-- <div
          class="bg-gray-900 text-gray-100 w-screen h-screen fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center text-6xl"
          style="z-index: 9999 !important;"
        >
          💡 UNDER MAINTENANCE
        </div> -->
          <Footer />
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  .loading-screen {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    z-index: 100 !important;
    top: 0;
    left: 0;
  }
  /* .loading-screen {
    width: calc(100vw - var(--side-menu-width));
    margin-left: var(--side-menu-width);
  } */
</style>
